import { Link } from 'react-router-dom'

const columns: { heading: string; links: { to: string; label: string }[] }[] = [
  {
    heading: 'Product',
    links: [
      { to: '/how-it-works', label: 'How it works' },
      { to: '/safety', label: 'Safety' },
      { to: '/minecraft', label: 'Fix Minecraft' },
      { to: '/download', label: 'Download' },
      { to: '/for-geeks', label: 'For geeks' },
    ],
  },
  {
    heading: 'Company',
    links: [
      { to: '/about', label: 'About' },
      { to: '/contact', label: 'Contact' },
      { to: '/faq', label: 'FAQ' },
      { to: '/status', label: 'Status' },
    ],
  },
  {
    heading: 'Legal',
    links: [
      { to: '/privacy', label: 'Privacy Policy' },
      { to: '/terms', label: 'Terms of Service' },
      { to: '/legal-faq', label: 'Legal FAQ' },
    ],
  },
]

/**
 * Site-wide footer. About, Contact, Privacy and Terms must stay linked here on
 * every page (AdSense site requirement; checked by scripts/check-dist-quality.mjs).
 */
export function SiteFooter({ tone = 'dark' }: { tone?: 'warm' | 'dark' }) {
  const warm = tone === 'warm'
  const muted = warm ? 'text-warm-navy/60' : 'text-gray-400'
  const link = warm
    ? 'text-warm-navy/70 hover:text-warm-coral'
    : 'text-gray-400 hover:text-white'

  return (
    <footer
      className={`border-t ${warm ? 'border-warm-peach/40 bg-warm-cream' : 'border-white/[0.06] bg-dark'}`}
      data-site-footer
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid gap-8 sm:grid-cols-4">
          <div>
            <Link to="/" className={`text-lg font-bold ${warm ? 'font-warm-display text-warm-coral' : 'font-display gradient-text'}`}>
              justfixit.AI
            </Link>
            <p className={`mt-2 text-sm leading-relaxed ${muted}`}>
              Describe the problem, review the plan, fix it with one button, undo it with another.
            </p>
          </div>
          {columns.map((col) => (
            <nav key={col.heading} aria-label={col.heading}>
              <p className={`text-xs font-semibold uppercase tracking-wider ${warm ? 'text-warm-navy' : 'text-gray-200'}`}>
                {col.heading}
              </p>
              <ul className="mt-3 space-y-2">
                {col.links.map((l) => (
                  <li key={l.to}>
                    <Link to={l.to} className={`text-sm transition-colors ${link}`}>
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>
        <p className={`mt-8 text-xs leading-relaxed ${muted}`}>
          Some partner links on this site are affiliate links, labeled &ldquo;Affiliate link&rdquo;. If you buy
          through one, we may earn a commission. Google ads, where shown, are labeled &ldquo;Advertisement&rdquo;.
          Details are in our{' '}
          <Link to="/privacy" className="underline">Privacy Policy</Link>.
        </p>
        <p className={`mt-3 text-xs ${muted}`}>&copy; {new Date().getFullYear()} justfixit.AI</p>
      </div>
    </footer>
  )
}
